// @flow

import React, { PureComponent } from "react";
import { get } from "lodash";
import type { Changes, RaceTypeCodeEnum } from "@tvg/types/Race";

import SurfaceChanges from "../../_organism/SurfaceChanges";
import HorseChanges from "../../_organism/HorseChanges";
import JockeyChanges from "../../_organism/JockeyChanges";
import { ChangesList, ChangesDivisor } from "./styled-components";

type Props = {
  /**
   * List of race changes
   */
  changes: Changes,
  /**
   * Race type code
   */
  raceTypeCode: RaceTypeCodeEnum,
  /**
   * Race Number
   */
  raceNumber: number
};

export default class RaceChanges extends PureComponent<Props> {
  static defaultProps = {
    changes: null,
    raceTypeCode: "T",
    raceNumber: 0
  };

  render() {
    const surface = get(this.props, "changes.surface", {});
    const horse = get(this.props, "changes.horse.scratched", []);
    const jockey = get(this.props, "changes.horse.jockey", []);

    return (
      <section>
        <ChangesList>
          {surface &&
            (surface.course ||
              surface.distance ||
              surface.tempRailDistance ||
              surface.condition) && (
              <ChangesDivisor>
                <SurfaceChanges
                  changes={surface}
                  raceNumber={this.props.raceNumber}
                />
              </ChangesDivisor>
            )}
          {horse && !!horse.length && (
            <ChangesDivisor>
              <HorseChanges
                changes={horse}
                raceTypeCode={this.props.raceTypeCode}
                raceNumber={this.props.raceNumber}
              />
            </ChangesDivisor>
          )}
          {jockey && !!jockey.length && (
            <ChangesDivisor>
              <JockeyChanges
                changes={jockey}
                raceTypeCode={this.props.raceTypeCode}
                raceNumber={this.props.raceNumber}
              />
            </ChangesDivisor>
          )}
        </ChangesList>
      </section>
    );
  }
}
